/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import {
  Box, Button, Grid, makeStyles, TextField, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Phone } from '@material-ui/icons';
import InputWrap from '../atoms/InputWrap';
import {
  CnpjValidation,
  EmailValidation, NameValidation, PhoneValidation,
} from '../functions/FormValidation';
import Hubspot from '../functions/Hubspot';
import TextFieldStatus from '../atoms/TextFieldStatus';
import MaskedTextField from '../molecules/MaskedTextField';
import WhatsappIcon from '../atoms/icons/WhatsappIcon';
import { maskBrazilPhone } from '../../helpers/FormantingHelper';
import SwitchAccountantCnpjStep from '../molecules/SwitchAccountantCnpjStep';

class FormValidator {
  static validateName(name) {
    if (!name) {
      return 'Nome é obrigatório';
    }
    try {
      if (!NameValidation({ firstname: name })) {
        return 'Nome inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Nome inválido';
    }
  }

  static validateEmail(email) {
    if (!email) {
      return 'E-mail é obrigatório';
    }
    try {
      if (!EmailValidation({ email })) {
        return 'E-mail inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'E-mail inválido';
    }
  }

  static validatePhone(phone) {
    if (!phone) {
      return 'Telefone é obrigatório';
    }
    try {
      if (!PhoneValidation({ phone })) {
        return 'Telefone inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'Telefone inválido';
    }
  }

  static validateCnpj(cnpj) {
    if (!cnpj) {
      return 'CNPJ é obrigatório';
    }
    try {
      if (!CnpjValidation({ cnpj })) {
        return 'CNPJ inválido';
      }
      return null;
    } catch (e) {
      return e.message || 'CNPJ inválido';
    }
  }

  static validateField(fieldName, value) {
    switch (fieldName) {
      case 'firstname':
        return this.validateName(value);
      case 'email':
        return this.validateEmail(value);
      case 'phone':
        return this.validatePhone(value);
      case 'cnpj':
        return this.validateCnpj(value);
      default:
        return null;
    }
  }

  // requireCnpj = false no formulario em duas etapas (TXM-626): la o CNPJ sai
  // da etapa 1 e vira opcional na etapa 2.
  static validateAll(data, requireCnpj = true) {
    const errors = {};

    const nameError = this.validateName(data.firstname);
    if (nameError) errors.firstname = nameError;

    const emailError = this.validateEmail(data.email);
    if (emailError) errors.email = emailError;

    const phoneError = this.validatePhone(data.phone);
    if (phoneError) errors.phone = phoneError;

    if (requireCnpj) {
      const cnpjError = this.validateCnpj(data.cnpj);
      if (cnpjError) errors.cnpj = cnpjError;
    }

    return errors;
  }
}

const useStyles = makeStyles(() => ({
  select: {
    '& .MuiSelect-icon': {
      right: '24px',
    },
  },
  button: {
    position: 'relative',
    width: '100%',
    background: '#0CB49D',
    '&:hover': {
      background: '#09796A',
    },
    '&:disabled': {
      background: '#BFD9D5',
    },

    '& .MuiButton-label': {
      color: '#FFFFFF',
    },
  },
}));

/**
 * @param {{
 *  onSuccess?: () => void,
 *  originModal?: (open: boolean) => void,
 *  whatsappOnly?: boolean,
 *  withSpace?: boolean
 *  notConvert?: boolean
 * }} props
 */
export default function SwitchAccountantFormDesk({
  onSuccess,
  originModal,
  whatsappOnly,
  withSpace,
  btnLigarTag,
  btnWppTag,
  btnLigarTagId,
  btnWppTagId,
  notConvert,
  twoStepCnpj = false,
}) {
  const classes = useStyles();
  const [errors, setErrors] = useState({});
  const [errorRoot, setErrorRoot] = useState();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // Duas etapas (TXM-626): step 1 = dados + canal, step 2 = CNPJ opcional.
  // O canal escolhido na etapa 1 fica guardado porque so e executado (abrir o
  // WhatsApp ou mostrar a confirmacao) depois da etapa 2.
  const [step, setStep] = useState(1);
  const [pendingChannel, setPendingChannel] = useState();

  const changeData = (value, field) => {
    const newData = { ...data, [field]: value };
    setData(newData);

    // Na etapa 2 o CNPJ e opcional: apagar o campo nao pode acender o erro
    // "CNPJ e obrigatorio". So o CNPJ preenchido e incompleto/invalido acusa.
    const error = field === 'cnpj' && twoStepCnpj && !value
      ? null
      : FormValidator.validateField(field, value);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (error) {
        newErrors[field] = error;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = FormValidator.validateAll(data, !twoStepCnpj);
    setErrors(newErrors);
    return newErrors;
  };

  // Verifica se o formulário está totalmente válido
  const isFormValid = () => {
    // Verifica se todos os campos obrigatórios estão preenchidos
    const hasAllRequiredFields = data.firstname && data.email && data.phone
      && (twoStepCnpj || data.cnpj);

    // Verifica se não há erros de validação
    const hasNoErrors = Object.keys(errors).length === 0;

    // Valida todos os campos para garantir que estão corretos
    const allFieldsValid = hasAllRequiredFields && hasNoErrors
      && !FormValidator.validateName(data.firstname)
      && !FormValidator.validateEmail(data.email)
      && !FormValidator.validatePhone(data.phone)
      && (twoStepCnpj || !FormValidator.validateCnpj(data.cnpj));

    return allFieldsValid;
  };

  // Etapa 2: vazio vale (e o "pular"); preenchido precisa ser um CNPJ valido.
  const isCnpjStepValid = () => !data.cnpj || !FormValidator.validateCnpj(data.cnpj);

  /**
   * Fecha o atendimento do jeito que sempre fechou: WhatsApp abre a conversa,
   * Ligacao mostra a confirmacao. No fluxo em duas etapas isso so roda depois
   * da etapa 2, senao quem escolheu WhatsApp sairia da pagina sem ver a etapa 2.
   *
   * @param {"Via Whatsapp" | "Via Ligação"} customerServiceType
   */
  const finishLead = (customerServiceType) => {
    setData({
      firstname: '',
      email: '',
      phone: '',
      city: '',
      state: '',
      activity: '',
      cityName: '',
      // So o fluxo em duas etapas limpa o CNPJ. Nos outros formularios este
      // reset sempre manteve o CNPJ, e mexer nisso esta fora desta tarefa.
      ...(twoStepCnpj && { cnpj: '' }),
    });
    setErrors({});
    setStep(1);
    setPendingChannel(undefined);
    if (customerServiceType === 'Via Whatsapp') {
      originModal && originModal(false);
      onSuccess();
      window.location.href = `https://api.whatsapp.com/send/?phone=${process.env.GATSBY_WHATSAPP_BUSINESS}&text=Falar%20com%20Especialista&type=phone_number&app_absent=0`;
    } else {
      onSuccess();
    }
  };

  /**
   * @param {"Via Whatsapp" | "Via Ligação"} customerServiceType
   */
  const handleSubmit = async (customerServiceType) => {
    setErrorRoot(undefined);
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setIsLoading(true);

    try {
      await Hubspot.sendToHubspotForm('trocar-contador', {
        ...data,
        customer_service: customerServiceType,
      });

      // Dispara um submit REAL no <form>: as variaveis nativas Form ID/Element
      // do GTM so sao preenchidas por um submit de DOM real, nao por push
      // manual no dataLayer. O onSubmit do form faz preventDefault, entao nao
      // ha navegacao real da pagina.
      const formEl = typeof document !== 'undefined'
        ? document.getElementById(notConvert ? 'contato-app' : 'form-trocar-contador')
        : null;
      if (formEl) {
        formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }

      if (!notConvert) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'form-trocar-contador',
          formId: 'form-trocar-contador',
          // Alimenta o Form ID do GTM por todos os caminhos: gtm.element (o <form>)
          // e gtm.elementId (a string), pra variavel dela resolver de qualquer jeito.
          'gtm.element': formEl,
          'gtm.elementId': 'form-trocar-contador',
          formName: 'Contato',
          formData: {
            data,
          },
        });
      }
      if (notConvert) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: 'contato-wpp',
          formId: 'contato-wpp',
          'gtm.element': formEl,
          'gtm.elementId': 'contato-wpp',
          formData: {
            data,
          },
        });
      }
      setIsLoading(false);

      // Duas etapas: o lead ja esta no HubSpot e a conversao ja contou no GTM.
      // Em vez de fechar o atendimento, segue para a etapa do CNPJ.
      if (twoStepCnpj) {
        setPendingChannel(customerServiceType);
        setErrors({});
        setStep(2);
        return;
      }

      finishLead(customerServiceType);
    } catch (error) {
      setErrorRoot('Desculpe, ocorreu um erro. Tente novamente mais tarde!');
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Etapa 2 do fluxo em duas etapas (TXM-626). Se o CNPJ foi preenchido, reenvia
   * o mesmo contato com ele: o HubSpot casa pelo e-mail, entao isso complementa
   * o lead da etapa 1 em vez de criar outro. Sem evento novo no GTM, porque a
   * conversao ja foi contada na etapa 1 e contar de novo dobraria a campanha.
   */
  const handleCnpjStepSubmit = async () => {
    setErrorRoot(undefined);

    if (!isCnpjStepValid()) {
      setErrors({ cnpj: FormValidator.validateCnpj(data.cnpj) });
      return;
    }

    setIsLoading(true);

    if (data.cnpj) {
      try {
        await Hubspot.sendToHubspotForm('trocar-contador', {
          ...data,
          customer_service: pendingChannel,
        });
      } catch (error) {
        // Nao trava o usuario: o lead ja esta no HubSpot desde a etapa 1, e
        // barrar aqui (principalmente antes do WhatsApp) perderia justamente o
        // atendimento. O que se perde e so o complemento do CNPJ.
      }
    }

    setIsLoading(false);
    finishLead(pendingChannel);
  };

  // Botão desabilitado quando: está carregando OU o formulário não está válido
  const disabled = isLoading || !isFormValid();

  if (twoStepCnpj && step === 2) {
    return (
      // id diferente do form da etapa 1 de proposito: com um campo so, apertar
      // Enter aqui dispara submit, e o gatilho de conversao do GTM olha o Form
      // ID "form-trocar-contador". Mesmo id contaria a conversao de novo.
      <form id="form-trocar-contador-cnpj" onSubmit={(e) => e.preventDefault()}>
        <SwitchAccountantCnpjStep
          cnpj={data.cnpj}
          error={errors.cnpj}
          errorRoot={errorRoot}
          isLoading={isLoading}
          disabled={isLoading || !isCnpjStepValid()}
          buttonClassName={classes.button}
          onChange={(value) => changeData(value, 'cnpj')}
          onSubmit={handleCnpjStepSubmit}
        />
      </form>
    );
  }

  return (
    <form
      id={notConvert ? 'contato-app' : 'form-trocar-contador'}
      // Os botoes NAO disparam submit de proposito (type=button + onClick):
      // o coletor de forms do HubSpot captura o evento de submit, e este form
      // nao deve mais ser coletado (o lead vai via API pro form nativo).
      onSubmit={(e) => e.preventDefault()}
    >
      <Typography style={{ paddingBottom: '16px' }}>
        Dados para migração
      </Typography>
      <Box style={{ paddingBottom: '36px' }}>
        <InputWrap>
          <TextField
            label="Nome"
            name="firstname"
            value={data.firstname}
            onChange={(e) => changeData(e.target.value, 'firstname')}
            error={Boolean(errors.firstname)}
            helperText={errors.firstname}
            disabled={isLoading}
            placeholder="Nome completo"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.firstname)}
                  value={data.firstname && !errors.firstname}
                />
              ),
            }}
          />

          <TextField
            label="E-mail"
            name="email"
            type="email"
            value={data.email}
            onChange={(e) => changeData(e.target.value, 'email')}
            error={Boolean(errors.email)}
            helperText={errors.email}
            disabled={isLoading}
            placeholder="seu_email@mail.com.br"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.email)}
                  value={data.email && !errors.email}
                />
              ),
            }}
          />
          <TextField
            onChange={(e) => {
              changeData(maskBrazilPhone(e.target.value), 'phone');
            }}
            value={data.phone}
            onClick={() => { changeData('+55 (', 'phone'); }}
            mask="+55 (99) 99999-9999"
            label="Telefone"
            type="tel"
            textFieldProps={{
              label: 'Telefone',
              name: 'phone',
              type: 'tel',
              value: data.phone,
              floating: true,
              error: Boolean(errors.phone),
              helperText: errors.phone,
            }}
            placeholder="+55 (DDD) 00000-0000"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              disabled: isLoading,
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.phone)}
                  value={data.phone && !errors.phone}
                />
              ),
            }}
          />
          {/* No fluxo em duas etapas o CNPJ vai para a etapa 2. */}
          {!twoStepCnpj && (
          <MaskedTextField
            onChange={(e) => changeData(e.target.value, 'cnpj')}
            mask="99.999.999/9999-99"
            textFieldProps={{
              label: 'CNPJ',
              name: 'cnpj',
              type: 'text',
              value: data.cnpj,
              floating: true,
              error: Boolean(errors.cnpj),
              helperText: errors.cnpj,
            }}
            placeholder="00.000.000/0000-00"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              disabled: isLoading,
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(errors.cnpj)}
                  value={data.cnpj && !errors.cnpj}
                />
              ),
            }}
          />
          )}
        </InputWrap>
      </Box>

      {errorRoot && <Typography component="span" style={{ color: '#D12E26' }}>{errorRoot}</Typography>}

      {withSpace && Object.keys(errors).length === 0 && <Box style={{ height: '30px' }} />}

      {!whatsappOnly && (
        <Typography style={{ marginBottom: '10px', color: '#383743' }}>
          Como você prefere ser atendido?
        </Typography>
      )}

      <Grid container spacing={4}>
        <Grid item xs={12} sm={whatsappOnly ? 12 : 6} style={{ display: whatsappOnly && 'flex', justifyContent: whatsappOnly && 'center' }}>
          <Button
            id={btnWppTagId}
            className={classes.button}
            style={{ width: whatsappOnly && '238px' }}
            disabled={disabled}
            name="wpp"
            type="button"
            onClick={() => {
              btnWppTag();
              handleSubmit('Via Whatsapp');
            }}
          >
            <WhatsappIcon
              height="20px"
              width="20px"
              style={{
                position: 'absolute', top: '50%', translate: '0 -40%', width: '20px', left: '18px',
              }}
            />
            VIA WHATSAPP
          </Button>
        </Grid>
        {!whatsappOnly && (
        <Grid item xs={12} sm={6}>
          <Button
            id={btnLigarTagId}
            className={classes.button}
            disabled={disabled}
            name="tel"
            type="button"
            onClick={() => {
              btnLigarTag();
              handleSubmit('Via Ligação');
            }}
          >
            <Phone style={{ position: 'absolute', left: '18px' }} />
            VIA LIGAÇÃO
          </Button>
        </Grid>
        )}
      </Grid>
    </form>
  );
}
SwitchAccountantFormDesk.defaultProps = {
  onSuccess: () => {},
  originModal: undefined,
  whatsappOnly: false,
  withSpace: false,
  btnWppTagId: undefined,
  btnLigarTagId: undefined,
  twoStepCnpj: false,
};
SwitchAccountantFormDesk.propTypes = {
  onSuccess: PropTypes.func,
  originModal: PropTypes.func,
  whatsappOnly: PropTypes.bool,
  withSpace: PropTypes.bool,
  btnWppTagId: PropTypes.string,
  btnLigarTagId: PropTypes.string,
  // Formulario em duas etapas, com o CNPJ opcional na segunda (TXM-626).
  // Ligado so no hero de /trocar-contador.
  twoStepCnpj: PropTypes.bool,
};
